<template>
  <div class="add-attr-name public-content">
    <div class="breadcrumb" style="background: #fff">{{ title }}</div>
    <div class="order-detail-basic">
      <el-form :model="attrData" label-width="100px">
        <el-form-item label="属性名:" prop="name">
          <el-input v-model="attrData.propKey" maxlength="10" placeholder="请输入" ref="iptRef"></el-input>
        </el-form-item>
      </el-form>
    </div>
    <div class="edit-button">
      <el-button round type="primary" @click="checkRepeat">确定</el-button>
    </div>
  </div>
</template>
 <script>
import { dictGet, dictUsable, dictAdd, dictUpdate } from '@/api/pms'
export default {
  name: 'AddAttrName',
  data () {
    return {
      title: '添加属性名',
      attrData: {
        id: '',
        pid: '',
        propKey: '',
        propVal: '',
        propUrl: '',
        isMallShow: 0
      }
    }
  },
  created () {
    this.getPrimaryAttr()
  },
  methods: {
    getPrimaryAttr () {
      if (this.$route.query.id === '-1') {
        return false
      }
      dictGet(this.$route.query.id).then((res) => {
        if (res.data.success) {
          this.title = '编辑属性名'
          this.attrData = res.data.data
        } else {
        }
      })
    },
    checkRepeat () {
      let name = {
        act: this.$route.query.id === '-1' ? 0 : 1,
        dictName: this.attrData.propKey,
        dictId: this.$route.query.id === '-1' ? null : this.$route.query.id,
        isVerifyKey: true
      }
      if (this.attrData.propKey === '') {
        this.$message.error('属性名不能为空')
        this.$refs.iptRef.focus()
        return false
      }
      dictUsable(name).then((res) => {
        if (res.data.success) {
          this.onsubmit()
        }
      })
    },
    onsubmit () {
      let _this = this
      if (this.title === '添加属性名') {
        dictAdd({
          parentId: _this.$route.query.parentId,
          propKey: _this.attrData.propKey,
          propUrl: null,
          propVal: null
        }).then((res) => {
          if (res.data.success) {
            this.$message.success('添加成功')
            this.$router.push('./attrmag')
          } else {
          }
        })
      }
      if (this.title === '编辑属性名') {
        dictUpdate({
          dictId: this.$route.query.id,
          dictVo: {
            parentId: this.$route.query.parentId,
            propKey: _this.attrData.propKey,
            propUrl: '',
            propVal: ''
          }
        }).then((res) => {
          if (res.data.success) {
            this.$message.success('编辑成功')
            this.$router.push('./attrmag')
          } else {
          }
        })
      }
    }
  }
}
</script>
 <style scoped lang="less">
</style>
